import { Component, OnInit, Inject } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CarteiraDeIntegradoresService } from '../../services/carteira-de-integradores.service';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { PremissasService } from "../../services/premissas.service";
import { PremissasSistema } from "../../models/premissas-sistema";

@Component({
  selector: 'app-gerenciar-colunas-carteira-integradores-modal',
  templateUrl: './gerenciar-colunas-carteira-integradores-modal.component.html',
  styleUrls: ['./gerenciar-colunas-carteira-integradores-modal.component.scss']
})
export class GerenciarColunasCarteiraIntegradoresModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  colunas = [];

  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(
    private dialogRef: MatDialogRef<GerenciarColunasCarteiraIntegradoresModalComponent>,
    private carteiraDeIntegradoresService: CarteiraDeIntegradoresService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private premissasService: PremissasService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.buscarPremissasSistema();
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.buscarColunas();

        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  recarregarColunas() {
    this.data.colunasSelecionadas.forEach(p => {
      if (this.colunas.some(c => c.id === p)) {
        this.colunas.find(c => c.id === p).status = true;
      }
    });
  }

  buscarColunas() {
    this.carregandoService.mostra('buscarColunas');

    this.carteiraDeIntegradoresService.consultarColunasOpcionais().subscribe(
      (colunas) => {
        this.colunas = colunas;

        if (!this.premissasSistema.habilitaOrcamento) {
          this.colunas = this.colunas.filter(c =>
            !c.descricao ||
            (!c.descricao.toLowerCase().includes('orçamento') &&
              !c.descricao.toLowerCase().includes('orcamento'))
          );
        }

        this.recarregarColunas();
        this.carregandoService.esconde('buscarColunas');
      },
      (erro) => {
        this.carregandoService.esconde('buscarColunas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    const result = this.colunas.filter(p => p.status).map(p => p.id);
    this.dialogRef.close(result);
  }
}
